import { makeStyles } from '@material-ui/core/styles';
import { colors } from '../theme';

const AppBarHeight = 70;

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    display: 'flex',
    flex: '1 1 auto',
  },
  toolbar: {
    height: 65,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
  },
  wrap: {
    width: '100%',
    height: '100vh',
    zIndex: '999',
    paddingTop: AppBarHeight,
  },
  content: {
    width: '100%',
    height: '100%',
    position: 'relative',
  },
  container: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  scroll: {
    width: '100%',
    height: '100%',

    '& .simplebar-scrollbar:before': {
      backgroundColor: theme.palette.primary.main,
      // background: `linear-gradient(0deg, ${theme.palette.primary.main} 30%, ${theme.palette.secondary.main}, ${theme.palette.primary.main} 70%)`,
      // backgroundSize: '200% 200%',
    },
  },
  grid: {
    width: '100%',
    height: '100%',
  },
  menuContainer: {
    position: 'absolute',
    width: '100%',
    height: AppBarHeight,
    zIndex: 1000,
    display: 'flex',
    flexDirection: 'row',
  },
  menuNav: {
    // justifyContent: 'flex-end',
    // overflowX: 'auto',

    '& button:last-child': {
      alignSelf: 'flex-end',
    },
    '& button span': {
      whiteSpace: 'nowrap',
    },
  },
  menuButtonOver: {},
  border: {
    '&.MuiLinearProgress-root': {
      height: 2,
      bottom: 0,
      position: 'absolute',
      width: '100%',
    },
  },
  grad: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: -20,
    width: 20,
    background: `linear-gradient(90deg, rgba(255,255,255,0) 0%, ${colors.gray} 50%)`,
  },
  preGrad: {
    position: 'relative',
    paddingTop: 14,
    paddingRight: 20,
  },
}));

export default useStyles;
